import { listSitemapPages as publicListSitemapPages } from './promote-seo-v1-headless-sitemap-entry-seo-sitemap-entries.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const listSitemapPages: MaybeContext<
  BuildRESTFunction<typeof publicListSitemapPages> &
    typeof publicListSitemapPages
> = /*#__PURE__*/ createRESTModule(publicListSitemapPages);

export { ItemType } from './promote-seo-v1-headless-sitemap-entry-seo-sitemap-entries.universal.js';
export {
  SitemapEntry,
  Image,
  Video,
  ListSitemapPagesRequest,
  CursorPaging,
  ListSitemapPagesResponse,
  PagingMetadataV2,
  Cursors,
  ListStaticSitemapPagesRequest,
  ListStaticSitemapPagesResponse,
  ListSitemapPagesOptions,
} from './promote-seo-v1-headless-sitemap-entry-seo-sitemap-entries.universal.js';
export { ItemTypeWithLiterals } from './promote-seo-v1-headless-sitemap-entry-seo-sitemap-entries.universal.js';
